import { render, staticRenderFns } from "./DetailGroupCampaign.vue?vue&type=template&id=2b6b5e69&scoped=true&"
import script from "./DetailGroupCampaign.vue?vue&type=script&lang=js&"
export * from "./DetailGroupCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b5e69",
  null
  
)

export default component.exports